<div class="myViewBody">
  <div class="d-flex flex-row ">
      <form [formGroup]="myViewsForm" (ngSubmit)="submitMyViews(myViewsForm.value)">
        <div style='padding-top: 2px; padding-left: 10px;'>
          <div
            class="infoText">
            <img _ngcontent-bnh-c182="" src="assets/Inbox/info-icon.svg" alt="" class="icon-setting-out ng-tns-c182-10"
              style='height: 16px;width: 16px;margin-right: 6px;' />
            <span>Last {{allowedMonthsInMyViews}} months data accessible from My view.
              Use QWYN search function for old records.</span>
          </div>
        </div>
        <div class="d-flex flex-row flex-nowrap align-items-center w-100 ps-2 pb-2">
          <label class="labelStyle" for="labelStyle">My view name:</label>
          <input id="myviews-view-name" type="text" placeholder="Start typing..." autocomplete="off" formControlName="viewName" [readonly]="!isNew"  class="w-400 search-box"/>
        </div>
        <div class="d-flex flex-row flex-nowrap align-items-center w-100 ps-2 pb-2">
          <label class="labelStyle" for="labelStyle">Search In:</label>
          <p-dropdown
                          [styleClass]="'standardDropdownStyle drop-down group-details-inp drop-admin'"
                          [options]="mailboxesJson"
                          placeholder="Search In"
                          (onChange)="getSelectedBox($event.value)"
                          [(ngModel)]="selBoxes"
                          [ngModelOptions]="{standalone: true}"
                          [ngClass]="{'standardDropdownStyle-open': isDropdownOpen}" (onShow)="isDropdownOpen = true"
                          (onHide)="isDropdownOpen = false"
                >
                  </p-dropdown>
        </div>
        <!-- <div class="d-flex flex-row flex-nowrap align-items-start w-100 pt-2 myview-view-label">
          <div class="d-flex flex-column ps-2 pb-7 align-top" style="width: 100%">
            
            <label for="from" class="labelStyle"> Search In</label>
                  <p-dropdown
                          [styleClass]="'standardDropdownStyle drop-down group-details-inp drop-admin'"
                          [options]="mailboxesJson"
                          placeholder="Search In"
                          (onChange)="getSelectedBox($event.value)"
                          [(ngModel)]="selBoxes"
                          [ngModelOptions]="{standalone: true}"
                          [ngClass]="{'standardDropdownStyle-open': isDropdownOpen}" (onShow)="isDropdownOpen = true"
                          (onHide)="isDropdownOpen = false"
                >
                  </p-dropdown>
          </div>
          <div *ngIf="false" class="d-flex flex-column ms-5 ps-5 pb-2">
            <div class="mb-2">
              Gridview Primary Columns
            </div>
            <div class="d-flex flex-column flex-nowrap myviews-elem">
              <div>
                <app-checkbox-list [placeholder]="'Quick Search...'" [name]="'groups'" [items]="myViewColumns" [listStyle]="{'height':'280px'}"
                  [scroll]="scroll" (onItemSelect)="getAssignedGroups($event)" [enableSelectAll]="true"
                  [search]="true"></app-checkbox-list>
              </div>
            </div>
          </div>
        </div> -->
        <div class="flex-row flex-nowrap align-items-end w-100">
          <div class="searchInTitle">
            Rules
          </div>
          <div id="builder-criteria"></div>
        </div>
        
            <!-- <p-tabView class="myViewTab" #adminTabs (onChange)="criteriaClick($event)" [styleClass]="'admin-tabview'" [scrollable]="false"
            [style]="{'max-height':'510px','width':'70em','margin-left': '27px', overflow: 'hidden'}">
              <p-tabPanel header="Definition">
                
              </p-tabPanel>

              <p-tabPanel header="Criteria">
                
              </p-tabPanel>
               
        </p-tabView> -->
        <div style="width: 100% ; display: block; margin-top: 10px; margin-bottom: 10px;">
          <div class="d-flex flex-row footer-btn-container"></div>
          <div class="buttonWrap">
            <button type="reset" class="btn clear-btn me-4" (click)="clearAndClose()">Reset</button>
            <button type="submit" class="btn search-btn">Apply</button>
          </div>
        </div>
        </form>
        <app-action-popup></app-action-popup>
  </div>
</div>
